export class ReservedRacksSoRequest {
    saleOrderId:number;
    rackId: number;

    constructor(saleOrderId:number,
        rackId: number) {
        this.rackId = rackId;
        this.saleOrderId = saleOrderId;
    }
}